import { signInExistingAccountStyles } from "@insite/content-library/Widgets/SignIn/SignInExistingAccount";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

signInExistingAccountStyles.forgotPasswordGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        justify-content: flex-end;
        align-items: center;
        font-family: "Roboto-Bold";
        padding: 0 15px;
    `,
};
signInExistingAccountStyles.forgotPasswordLink = {
    typographyProps: {
        size: 15,
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                    `,
                    css`
                        font-size: 14px;
                    `,
                    null,
                    css`
                        font-size: 13px;
                    `,
                    null,
                ])}
        `,
    },
};

signInExistingAccountStyles.rememberMeGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        font-family: "Roboto-Bold";
        padding: 0px 15px;
    `,
};

signInExistingAccountStyles.rememberMeCheckbox = {
    css: css`
        > label {
            font-size: 15px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: 14px;
                    `,
                    css`
                        font-size: 14px;
                    `,
                    null,
                    css`
                        font-size: 13px;
                    `,
                    null,
                ])}
        }
    `,
};
